<template>
  <div class="card" style="border-left: none !important">
    <div class="card-body">
      <h4 class="card-title">{{$t("page.content_dashboard.graficas.capacitacion_two.title")}}</h4>
      <h6>{{$t("page.content_dashboard.graficas.capacitacion_two.sub_title")}}</h6>
      <div v-if="cargando" class="d-flex justify-content-center align-items-center m-t-20" style="height: 223px">
        <div class="spinner-border" role="status">
          <span class="sr-only">{{ $t("page.general.cargar") }}</span>
        </div>
      </div>
      <div v-show="!cargando" id="visitor" style="height: 223px; width: 100%" class="m-t-20"></div>
      <!-- row -->
      <div v-show="!cargando" class="row m-t-30 m-b-15">
        <!-- column -->
        <div
          class="col-md birder-right text-left"
          v-for="(item, index) in columns"
          :key="'plata' + index"
        >
          <h4 class="m-b-0">
            {{ item[1] }}%
            <!-- <small>
              <i class="ti-arrow-up text-success"></i>
            </small> -->
          </h4>
          {{ item[0] }}
        </div>
        <!-- column -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cargando: true,
      columns: [
        // ["Guerrero", 30],
        // ["Universidad", 12],
        // ["Churubusco", 28],
        // ["Pesqueria", 20],
        // ["Otras", 10],
      ],
      capacitacionPorEstructura: [],
    };
  },
  methods: {
    getCapacitacionPorEstructura() {
      this.cargando = true;
      this.capacitacionPorEstructura = [];
      this.$http
        .get("dashboard/getCapacitacionPorEstructura")
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.capacitacionPorEstructura = respuestaJson;
          const formatted = this.capacitacionPorEstructura.map(item => {
            return [item.area, item.porcentaje];
          });
          this.columns = formatted;
          this.cargando = false;
          this.$nextTick(() => {
            this.Configurar_Grafica();
          });
        })
        .catch(error => {
          toastr.clear();
          toastr.error(
            this.$t("page.estructura_puestos_content.js_scope.problemas_n2")
          );
          this.cargando = false;
        });
    },
    Configurar_Grafica() {
      var chart = c3.generate({
        bindto: "#visitor",
        data: {
          columns: this.columns,

          type: "donut",
          onclick: function (d, i) {},
          onmouseover: function (d, i) {},
          onmouseout: function (d, i) {},
        },
        donut: {
          label: {
            show: false,
            // format: function (value, ratio, id) {
            //   return d3.format('.1%')(ratio); // ratio = 0.913 → "91.3%"
            // }
          },

          width: 20,
        },

        legend: {
          hide: true,
          //or hide: 'data1'
          //or hide: ['data1', 'data2']
        },
        color: {
          pattern: ["#FF3300", "#FF9900", "#00AB53", "#007299", "#ff5733", "#56cd1e", "#531ecd"],
        },
      });
    },

  },
  mounted() {
    this.getCapacitacionPorEstructura();
  },
};
</script>


<style scoped>
.card /deep/ .c3-chart-arcs-title::first-letter {
  text-transform: uppercase !important;
}
</style>




// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/CapacitacionxRegion/CapacitacionxRegion.vue